'use strict';

angular.module('far.club')
    .controller('ClubMembershipController', function ($filter, $log, $scope, $window, $http, form, autocomplete, userMembership, formsUtils, inviteUserForm, http) {
        var vm = {
            progress: true,
            submitted: false,
            show_error: false,
            club_required: true,
            club_checkbox: false,
            max: null,
            club: null,
            users: [],
	    members_active:[],
	    members_active_paid:[],
            members_stopped:[],
            form: {},
            autoCompleteSelect: {
                country: null,
                region: null,
                city: null
            },
            submit: function () {
                vm.submitted = true;
                vm.show_error = true;

                if ( !$scope.membershipForm.$valid ) {
                   return false;
                }

                vm.form.save()
                    .then(function () {
                        var data = {
                            members: [],			   			
                            members_new: [],
                            members_invite: []                        };

                        if ( vm.form.members_active.length ) {
                            angular.forEach(vm.form.members_active, function(member) {
                                data.members.push(member.id);
                            });
                        }
			 if ( vm.form.members_stopped.length ) {
                            angular.forEach(vm.form.members_stopped, function(member) {
                                data.members.push(member.id);
                            });
                        }


                        if ( vm.form.members_new.length ) {
                            angular.forEach(vm.form.members_new, function(member_new) {
                                data.members_new.push(member_new.id);
                            });
                        }

                        if ( vm.form.members_invite.length ) {
                            data.members_invite = angular.merge([], vm.form.members_invite);
                        }

                        $http.post(Routing.generate('api_post_club_membership', {club: vm.club}), data)
                            .then(function (response) {
                                $window.location.href = response.data.url;
                            }, function errorCallback(response) {
                                $log.error(response);
                            });
                    }, function errorCallback(response) {
                        response = http.authenticationListener(response);

                        vm.submitted = false;

                        $log.error(response);
                    });
            },
            fields: form('ClubMembership'),
            constructor: function (user, club,fee, price, max) {
                vm.form = userMembership.get(user, function () {
                    vm.form.members = [];
		    vm.form.members_active =[];
		    vm.form.members_active_paid =[];
                    vm.form.members_stopped =[];
                    vm.form.members_new = [];
                    vm.form.members_invite = [];
                    vm.form.counter = 1;
                    vm.far_fee = price;
                    vm.club = club;
		    vm.local_fee=fee?fee:0;
		    vm.form.price=vm.far_fee;
		   if(vm.local_fee)
			vm.form.price=vm.form.price+vm.local_fee;
		    vm.form.confirmation=true;
			

                    $http.get(Routing.generate('api_get_club_users', {club: vm.club}))
                        .then(function (response) {
                            response.data.forEach(function(clubUser) {
                                if ( clubUser.member_card && clubUser.member_date_end ) {
                                    clubUser.fio_desc += '         Действующий до ' + $filter('date')(clubUser.member_date_end, "dd-MM-yyyy");
                                        if (
                                            $filter('date')(clubUser.member_date_end, "yyyy") > $filter('date')(new Date(), "yyyy")
                                            || ($filter('date')(clubUser.member_date_end, "yyyy") == $filter('date')(new Date(), "yyyy") && ($filter('date')(new Date(), "M") != 11 && $filter('date')(new Date(), "M") != 12) )
                                        ) {
                                            clubUser.disabled = true;
						vm.members_active_paid.push(clubUser);

                                        }
					else{
						vm.members_active.push(clubUser);

					}


                                }
				else{
				vm.members_active.push(clubUser);
				
				}

                                vm.users.push(clubUser);
                            });

                            vm.progress = false;
                        }, function errorCallback(response) {
                            $log.error(response);
                        });
                });
            },
            counter: function (type) {
                if (type == 1) {
                    if ( vm.form.counter < vm.max ) {
                        vm.form.counter++;
                    }
                } else {
                    if ( vm.form.counter > 1 ) {
                        vm.form.counter--;
                    }
                }
            },
            getCounter: function () {
                return vm.form.counter + ' ' + formsUtils.numEnding( vm.form.counter, ['год', 'года', 'лет'] );
            }
        };

        vm.fields
            .addField('members_active', 'checkboxCollection', {
                checkbox: {
                    label: 'fio_desc',
                    model: 'selected'
                }
            }, vm.members_active)
	.addField('members_active_paid', 'checkboxCollection', {
                checkbox: {
                    label: 'fio_desc',
                    model: 'selected'
                }
            }, vm.members_active_paid)

	 
            .addField('members_new', 'userSelect', {
                uiSelectOptions: {
                    match: {
                        placeholder: 'Выберите участника...'
                    },
                    choices: {
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "members_new",{unpaid:""})'
                    },
                    refreshAutoComplete: function(search, term, object) {
                        var users = [];
                       if ( vm.users.length ) {
                            for ( var i in vm.users ) {
                                users.push( vm.users[i].id );
                            }
                        }
                        if ( vm.form.members_new.length ) {
                            for ( var i in vm.form.members_new ) {
                                if ( vm.form.members_new[i].id ) {
				users.push( vm.form.members_new[i].id );
                                    
                                }
                            }
                        }

                        return autocomplete.refreshAutoComplete(search, term, object, {
                            not_id: users,
			    unpaid: true
                        });
                    },
                    onSelect: function (item, model, options) {
                        if (item) {
                            vm.form.members_new[options.index] = item;
                        }
                    }
                }
            }, autocomplete.get('members_new'))
            .addField('members_invite', 'collection', {
                validators: {
                    required: true
                },
                label: 'Пригласить участника',
                buttons: {
                    add: 'Пригласить участника',
                    remove: 'Удалить участника'
                },
                fieldData: {
                    doDelete: function(item, model, $index) {
                        vm.form.members_invite.splice($index, 1);

                        item.deleted_at = new Date();
                    },
                    filterArray: function(item) {
                        return !item.deleted_at;
                    },
                    ngRepeat: 'item in model|filter:field.filterArray track by $index'
                }
            }, inviteUserForm)
            .addField('phone', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Телефон'
                }
            })
            .addField('email', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'E-mail'
                }
            })
            .addField('last_name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Фамилия'
                }
            })
            .addField('first_name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Имя'
                }
            })
            .addField('middle_name', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Отчество'
                }
            })
            .addField('counter', 'text', {
                validators: {
                    required: true,
                    numericOnly: ''
                },
                options: {
                    placeholder: '1',
                    class: 'form-counter__input',
                    maxlength: 2
                }
            })
            .addField('country', 'uiSelect', {
                validators: {
                    required: true
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-350'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Страна',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Country", "country")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        if (item) {
                            vm.autoCompleteSelect.country = item.id;
                            vm.autoCompleteSelect.region = null;
                            vm.autoCompleteSelect.city = null;

                            vm.form.country = item;

                            vm.fields.$fields.region.items = [];
                            vm.fields.$fields.city.items = [];
                        }
                    }
                },
                fieldData: {
                    name: 'country'
                }
            }, autocomplete.get('country'))
            .addField('region', 'uiTypeahead', {
                validators: {
                    required: true
                },
                label: null,
                options: {
                    class: 'form__item',
                    placeholder: 'Регион',
                    tabindex: 10,
                    uibTypeahead: "row as row.name for row in field.refreshAutoComplete($viewValue, 'Region')"
                },
                fieldData: {
                    clearBtn: true,
                    refreshAutoComplete: function (name, term) {
                        return autocomplete.refreshAutoComplete(name, term, null, vm.autoCompleteSelect)
                    }
                }
            })
            .addField('city', 'uiTypeahead', {
                validators: {
                    required: true
                },
                label: null,
                options: {
                    class: 'form__item',
                    placeholder: 'Населенный пункт',
                    uibTypeahead: "row as row.name for row in field.refreshAutoComplete($viewValue, 'City')"
                },
                fieldData: {
                    clearBtn: true,
                    refreshAutoComplete: function (name, term) {
                        if (angular.isObject(vm.form.region)) {
                            vm.autoCompleteSelect.region = vm.form.region.id;
                        } else {
                            vm.autoCompleteSelect.region = null;
                        }

                        return autocomplete.refreshAutoComplete(name, term, null, vm.autoCompleteSelect)
                    }
                }
            })
            .addField('post_index', 'text', {
                validators: {
                    required: true,
                    numericOnly: ''
                },
                options: {
                    placeholder: 'Индекс'
                }
            })
            .addField('address', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Улица'
                }
            })
            .addField('house', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Дом'
                }
            })
            .addField('building', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Кор.'
                }
            })
            .addField('apartment', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Кв.'
                }
            })
        ;

        return vm;
    });
